import { BalancesLabels } from '../i18n/balances-labels';

export interface Disclaimer {
    legendSymbol: string;  // If exists, it'd be displayed instead of its positioning (index) value.
    legendByIndex: boolean;  // Whether the legend is dynamically based on index.
    key: string;    // A key string constant defined in i18n label that would be translated to actual disclaimer text.
    show: boolean;  // For easily check to display or not.
    showCounter: number;  // Same disclaimer may be requested by multiple components.  This helps to decide show/no show.
    className: string; // Addtional className if needed.
}

// Note: order is important and rendered as listed. So:
// if a disclaimer uses sequence number as legend symbol, then insert it within the index section.
// else insert in the default or specific symbol section.
export function disclaimerList(): Disclaimer[] {
    return [
        // use index legend symbol.
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_LONGMARKETVALUE,
            'show': false, 'className': 'longMarketValue', 'showCounter': 0
        },
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_SECURITYOWED,
            'show': false, 'className': 'securityOwed', 'showCounter': 0
        },
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_CASHMGTINT,
            'show': false, 'className': 'cashMgtInt', 'showCounter': 0
        },
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_ANNUITYVALUES,
            'show': false, 'className': 'annuityValues', 'showCounter': 0
        },
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_FUNDSAVAILTOTRADE,
            'show': false, 'className': 'fundsAvailToTrade', 'showCounter': 0
        },
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_NOTALLMARGINABLE,
            'show': false, 'className': 'notAllMarginable', 'showCounter': 0
        },
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_CALCULATEDFUNDSDUE,
            'show': false, 'className': 'calculatedFundsDue', 'showCounter': 0
        },
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_CASHBALANCE,
            'show': false, 'className': 'cashBalance', 'showCounter': 0
        },
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_MARKETVALUE,
            'show': false, 'className': 'marketValue', 'showCounter': 0
        },
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_AVAILABLECREDIT,
            'show': false, 'className': 'availableCredit', 'showCounter': 0
        },
        {
            'legendSymbol': '0', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_CREDITLIMIT,
            'show': false, 'className': 'creditLimit', 'showCounter': 0
        },
        // Specific legend symbol.
        {
            'legendSymbol': '\u2020', 'legendByIndex': false, 'key': BalancesLabels.DISCLAIMER_QUOTEDELAYED,
            'show': false, 'className': 'quoteDelayed', 'showCounter': 0
        },
        // No legend (default/general)
        {
            'legendSymbol': 'noLegend', 'legendByIndex': false, 'key': BalancesLabels.DISCLAIMER_POSITIONPRICING,
            'show': true, 'className': 'positionsPricing', 'showCounter': 0
        },
        {
            'legendSymbol': 'noLegend', 'legendByIndex': false, 'key': BalancesLabels.DISCLAIMER_HOWFIELDSCALCULATED,
            'show': true, 'className': 'howFieldsCalculated', 'showCounter': 0
        },
        {
            'legendSymbol': 'noLegend', 'legendByIndex': false, 'key': BalancesLabels.DISCLAIMER_INFOPURPOSESONLY,
            'show': true, 'className': 'infoPurposesOnly', 'showCounter': 0
        }
    ];
}
